import { Box } from '@chakra-ui/react';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Condition, Iteration } from 'Component/others';
import useGetPresenceHistory from 'Domain/host-presence-content/useGetPresenceHistory';
import CardReportPresence from 'View/host-presence-content/components/card-report-presence';
import { useHostPresenceContentState } from 'View/host-presence-content/state';
import ListPresenceContentSkeleton from 'View/host-presence-content/components/skeleton/list-presence-content';
import EmptyState from 'Component/empty-state';

import styles from './styles.module.css';

const ListReportPresence = () => {
  const { updateFilterState, filterState } = useHostPresenceContentState();

  const { data: presenceListData, isFetching: isLoadingPresenceList } = useGetPresenceHistory({ params: filterState });

  const hasMoreData = presenceListData?.currentPage < presenceListData?.totalPage;
  const hasData = presenceListData?.presences?.length > 0;
  const isInitialLoading = isLoadingPresenceList && filterState.page === 1;

  const onLoadMore = () => {
    updateFilterState({ page: filterState.page + 1 });
  };
  return (
    <InfiniteScroll dataLength={presenceListData?.presences?.length ?? 0} hasMore={hasMoreData} next={onLoadMore} scrollThreshold="90%">
      <Box className={styles['list-report-presence__container']}>
        <Condition statement={!isInitialLoading} fallback={<ListPresenceContentSkeleton />}>
          <Condition statement={hasData} fallback={<EmptyState />}>
            <Iteration items={presenceListData?.presences} render={(item, index) => <CardReportPresence key={index} data={item} />} />
          </Condition>
        </Condition>
      </Box>
    </InfiniteScroll>
  );
};

export default ListReportPresence;
